import { render } from "./schools-base.vue?vue&type=template&id=1594ca50"
import script from "./schools-base.js?vue&type=script&lang=js"
export * from "./schools-base.js?vue&type=script&lang=js"

import "./schools-base.vue?vue&type=style&index=0&id=1594ca50&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__